export const APP = {
  DRAWER: {
    WIDTH: 240,
  },
  ROUTES: {
    ROOT: '/',
    SEARCH: '/search',
    DASHBOARD: '/home',
    NUTRITIONS: '/nutritions',
    INGREDIENTS: '/ingredients',
    RECIPES: '/recipes',
  },
};
